import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer/Footer'
import Carousel from '../Components/Carousel/Carousel'
import Categories from '../Components/Category/Categories'
import Products from '../Components/Product/Products'
import Experience from '../Components/Experience/Experience'

function Dashboard() {

    /* const downloadApp = () => {
        if (isAppleDevice) {
            // iPhone / iPad / Mac
            window.open(
                "https://apps.apple.com/in/app/mwc-meet-with-celebrity/id6775950358",
                "_blank"
            );
        } else {
            // Android and all other devices
            window.open(
                "https://play.google.com/store/apps/details?id=com.meetwithcelebrity",
                "_blank"
            );
        }
    }; */

    return (
        <div>
            <Carousel />
            <Categories />
            <Products />
            <Experience />
        </div>
    )
}

export default Dashboard